export enum FormMessageType {
  PreSubmit = 'PreSubmit',
  Submit = 'Submit',
  AfterSubmit = 'AfterSubmit',
  OnRedirect = 'OnRedirect',
  SetControl = 'SetControl',
  SetHeight = 'SetHeight',
  SetFormId = 'SetFormId',
  FormReady = 'FormReady',
  SetFormScript = 'SetFormScript',
}
